module.exports = __webpack_public_path__ + "img/Curry Icon - charcoal.41c3a54c.svg";